import { useState } from "react";
import { BsCalendar2Check } from "react-icons/bs";
import ExpandPanel from "./ExpandPanel";

export default function ConfirmedWidget({ bookings }: any) {
  const [isVisible, setVisible] = useState<boolean>(false);
  const data = bookings.filter(
    (item: any) => item?.is_confirmed === true && item?.wip === undefined
  );
  return (
    <div className="col-span-12 sm:col-span-3 border px-4 py-2 flex items-center bg-white hover:bg-red-50">
      <button className="flex w-full" onClick={() => setVisible(true)}>
        <div className="flex justify-center items-center rounded-lg border h-12 w-12 bg-red-100">
          <BsCalendar2Check size={24} />
        </div>
        <div className="border-l ml-2">
          <div className="pl-4 ">Confirmed Bookings</div>
          <div className="pl-4 text-xl text-black text-left font-bold">
            {data?.length}
          </div>
        </div>
      </button>

      <ExpandPanel
        isVisible={isVisible}
        setVisible={setVisible}
        data={data}
        title={"Confirmed Bookings"}
      />
    </div>
  );
}
